"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.spaceHierarchyFormatter = void 0;
var flat = function (nestedArray) { return nestedArray.reduce(function (a, b) { return __spreadArray(__spreadArray([], a, true), b, true); }, []); };
function spaceHierarchyFormatter(hierarchy) {
    function recurseHierarchy(space, ancestry, depth) {
        if (ancestry === void 0) { ancestry = []; }
        if (depth === void 0) { depth = -1; }
        var parentId = ancestry.length > 0 ? ancestry[0].id : null;
        if (!space.children) {
            // Leaf of the tree
            return [{ depth: depth + 1, ancestry: ancestry, children: [], space: __assign(__assign({}, space), { parentId: parentId }) }];
        }
        else {
            // Regular node in the tree
            var children = flat(space.children.map(function (child) { return recurseHierarchy(child, __spreadArray([space], ancestry, true), depth + 1); }));
            return __spreadArray([
                {
                    depth: depth + 1,
                    ancestry: ancestry,
                    children: children.map(function (c) { return c.space; }),
                    space: __assign(__assign({}, space), { parentId: parentId }),
                }
            ], children, true);
        }
    }
    return flat(hierarchy.map(function (space) { return recurseHierarchy(space); }));
}
exports.spaceHierarchyFormatter = spaceHierarchyFormatter;
//# sourceMappingURL=formatter.js.map